import { JoinedCheck, PendingDisplay } from "./index.ts";
import { CONTEST_ENTRY_STATUS } from "utils/constants.ts";
import { ContestEntry } from "interfaces/leaderboard/contest.ts";

interface StatusProps {
  contestEntry: ContestEntry;
}

const ContestEntryStatusIcon = ({ contestEntry }: StatusProps) => {
  return contestEntry.status === CONTEST_ENTRY_STATUS.VALID
    ? <JoinedCheck />
    : <PendingDisplay />;
};

export default ContestEntryStatusIcon;